import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { WireTransferModalComponent } from './wire-transfer-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxKjuaModule } from 'ngx-kjua';

@NgModule({
  imports: [
    NgxKjuaModule,
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule
  ],
  exports: [],
  declarations: [WireTransferModalComponent],
  providers: []
})
export class WireTransferModalModule {
}